import React from "react";

export default function About() {
  return (
    <div style={styles.page}>
      <h2>À propos de DNS</h2>
        <div style={styles.paragraphe}>
            <p> DNS, pour “Do Not Start”, est une entreprise fondée en 2026 à Paris avec une mission ambitieuse : moderniser et fluidifier l’achat et la revente de dossards pour les événements sportifs, partout en France et, à terme, à l’international.</p>
            <p>Convaincu que le sport doit être accessible à toutes et tous, et passionné de disciplines d’endurance, j’ai lancé ce projet suite à une expérience personnelle : une fracture à la cheville m’a empêché de participer à plusieurs courses, sans jamais réussir à revendre mes dossards.</p> 
            <p>J’ai non seulement perdu de l’argent, mais aussi bloqué l’opportunité pour d’autres sportifs de participer.</p>
            <p>Les plateformes de billetterie existantes, souvent peu intuitives et datées, ne répondaient ni à mes besoins ni à mes attentes en matière d’expérience utilisateur.</p>
        </div>

        <div style={styles.paragraphe}>
            <p>Aujourd’hui, DNS propose une plateforme moderne et intuitive dédiée à la billetterie d’événements sportifs :</p>
            <ul style={styles.list}>
                <li>Inscription simple et rapide aux courses partenaires</li>
                <li>Possibilité de revendre son dossard en un clic, sans justificatif ni paperasse</li>
                <li>Mise en relation directe entre organisateurs et sportifs intéressés</li>
            </ul>
        </div>

        <div style={styles.paragraphe}>
            <p>Je travaille en étroite collaboration avec les organisateurs pour faciliter la mise en ligne de leurs événements et offrir une nouvelle visibilité auprès des sportifs.</p> 
            <p>DNS s’adresse donc aussi bien aux organisateurs de courses qu’aux sportifs en quête d’événements… ou dans l’imprévu, souhaitant revendre facilement leur participation.</p>
        </div>

        <div style={styles.paragraphe}>
            <p>Au cœur du projet :</p>
            <ul style={styles.list}>
            <li>Accessibilité : démocratiser l’accès au sport</li>
            <li>Innovation : proposer une expérience utilisateur moderne et agréable</li>
            <li>Soutien au monde sportif : accompagner clubs et événements locaux dans leur gestion</li>
            </ul>
        </div>

        <div style={styles.end}>
            <p>DNS est en phase de lancement, pilotée pour l’instant en solo par un ingénieur passionné, mais ambitionne de devenir un acteur incontournable en France, puis en Europe et à l’international.</p>
            <p>Envie d’en savoir plus, de rejoindre l’aventure ou de référencer votre course ? Retrouvez toutes les informations et contactez-moi sur [votre site], ou suivez DNS sur [vos réseaux sociaux].</p>
            <p>La simplicité au service du sport, pour que chaque dossard trouve son coureur !</p>
        </div>
    </div>
  );
}

const styles = {
    page: {
        padding: 32,
    },
    paragraphe: {
        marginBottom: 16,
        lineHeight: 1.6,
    },
    list : {
        marginLeft: 40,
    },
    end: {
        marginTop: 32,        
        fontStyle: "italic",
    }
}
